// jsPDF's built-in Helvetica uses WinAnsi encoding, so Unicode characters
// (fractions, ellipses, smart quotes, special dashes/symbols) drop or render
// incorrectly. Normalize text to ASCII-safe equivalents before drawing.
const MAP = {
  "\u00BC": "1/4", // ¼
  "\u00BD": "1/2", // ½
  "\u00BE": "3/4", // ¾
  "\u2150": "1/7", // ⅐
  "\u2151": "1/9", // ⅑
  "\u2152": "1/10", // ⅒
  "\u2153": "1/3", // ⅓
  "\u2154": "2/3", // ⅔
  "\u2155": "1/5", // ⅕
  "\u2156": "2/5", // ⅖
  "\u2157": "3/5", // ⅗
  "\u2158": "4/5", // ⅘
  "\u2159": "1/6", // ⅙
  "\u215A": "5/6", // ⅚
  "\u215B": "1/8", // ⅛
  "\u215C": "3/8", // ⅜
  "\u215D": "5/8", // ⅝
  "\u215E": "7/8", // ⅞
  "\u2026": "...", // …
  "\u2014": "-", // —
  "\u2013": "-", // –
  "\u2012": "-", // ‒
  "\u2011": "-", // ‑
  "\u2010": "-", // ‐
  "\u2018": "'", // '
  "\u2019": "'", // '
  "\u201A": "'", // ‚
  "\u201B": "'", // ‛
  "\u201C": '"', // "
  "\u201D": '"', // "
  "\u201E": '"', // „
  "\u201F": '"', // ‟
  "\u00A0": " ", // non-breaking space
  "\u2022": "-", // • bullet
  "\u00D7": "x", // ×
  "\u00F7": "/", // ÷
  "\u2265": ">=", // ≥
  "\u2264": "<=", // ≤
  "\u2248": "~", // ≈
  "\u2192": "->", // →
  "\u2190": "<-", // ←
  "\u00B0": " deg", // ° (degree)
  "\u00B1": "+/-", // ±
  "\u00B5": "u", // µ
  "\u2122": "(TM)", // ™
  "\u00A9": "(c)", // ©
  "\u00AE": "(R)", // ®
};

export function pdfText(value) {
  if (value == null) return "";
  return String(value)
    .split("")
    .map((ch) => MAP[ch] ?? ch)
    .join("")
    .replace(/[^\x20-\x7E]/g, ""); // strip any remaining non-ASCII
}